export default __webpack_public_path__ + "static/media/instagram.4579f265.svg";